import { useAuth } from '@/contexts/AuthContext';

// Cache partition only. Authorization remains with authenticated server reads.
export function useKnowledgeIdentity() {
  const { user, tenantId, isAuthenticated, isLoading, identityEpoch } =
    useAuth();
  const userId = user?.id ?? '';
  const tenant = tenantId ?? '';
  return {
    userId,
    tenantId: tenant,
    key: JSON.stringify([tenant, userId, identityEpoch ?? 0]),
    ready: Boolean(isAuthenticated && !isLoading && userId && tenant),
  };
}
